export {}

export const FIRST_VISIT_URL_NAME = 'first_visit_url'
